import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "shots" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "copy" }
const _hoisted_5 = { class: "kicker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "stock",
    "aria-label": _ctx.t('homeStockLooksTitle')
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.looks, (look, index) => {
        return (_openBlock(), _createElementBlock("figure", {
          key: look.titleKey,
          class: _normalizeClass('shot-' + index)
        }, [
          _createElementVNode("img", {
            src: look.src,
            alt: _ctx.t(look.titleKey)
          }, null, 8, _hoisted_3),
          _createElementVNode("figcaption", null, _toDisplayString(_ctx.t(look.titleKey)), 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('homeStockLooksKicker')), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('homeStockLooksTitle')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.t('homeStockLooksText')), 1)
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}